import React from "react";
import { Link } from "../../utils/customLink";

import ArrowRightBigIcon from "../../images/icons/arrow-right-big-icon.inline.svg";
import ArrowRightIcon from "../../images/icons/arrow-right-icon.inline.svg";

const ViewButton = ({
  to = "#",
  ctaViewLabel = "View program",
  buttonStyle = ""
}) => {
  return (
    <Link
      to={to}
      className={`view-program-link group relative z-10 flex flex-row items-center justify-center 
              px-2 py-2 text-sm border rounded-full dark:rounded-sm
              text-black-lighter dark:text-white  
              hover:text-white dark:hover:text-gray-darker
              border-generic-text dark:border-white 
              hover:bg-black-lighter dark:hover:bg-white w-full ${buttonStyle}`}
    >
      <p className="text-[16px] leading-genericCta font-bold pr-2">
        {ctaViewLabel}
      </p>
      <ArrowRightBigIcon className="block fill-black-lighter group-hover:fill-white dark:hidden" />
      <ArrowRightIcon className="hidden stroke-white group-hover:stroke-gray-darker dark:block " />
    </Link>
  );
};

export default ViewButton;
